import supabase from "./supabase";

// Function to sign up a new user
export const signUp = async (email, password) => {
  const { user, error } = await supabase.auth.signUp({
    email,
    password,
  });

  if (error) throw error;
  return user;
};

// Function to log in an existing user

export const logIn = async ({ email, password }) => {
  const { data, error } = await supabase.auth.signInWithPassword({
    email,
    password,
  });

  if (error) {
    throw error; // This ensures that the error is caught by the `onError` handler
  }

  return data; // Make sure this returns an object containing a `user` property
};

// Function to log out the current user
export const logOut = async () => {
  const { error } = await supabase.auth.signOut();

  if (error) throw error;
  return true;
};

// Function to update user information
export const updateUser = async (updates) => {
  const { user, error } = await supabase.auth.update(updates);

  if (error) throw error;
  return user;
};

// Function to send password recovery email
export const sendPasswordRecovery = async (email) => {
  const redirectTo = `${window.location.origin}/auth_passwordreset`;
  const { data, error } = await supabase.auth.resetPasswordForEmail(email, {
    redirectTo,
  });

  if (error) throw error;
  return data;
};

// Function to create a new user in a specific table
export const createUser = async (tableName, userData) => {
  const { data, error } = await supabase.from(tableName).insert([userData]);

  if (error) throw error;
  return data;
};

// Function to update an existing user in a specific table
export const updateUserInTable = async (tableName, userId, updates) => {
  const { data, error } = await supabase
    .from(tableName)
    .update(updates)
    .eq("id", userId);

  if (error) throw error;
  return data;
};

export default supabase;

// TODO how to use this function?

/*  Sign Up:

    import { signUp } from './apiUsers';

    signUp('email@example.com', 'password123')
      .then(user => console.log('User signed up:', user))
      .catch(error => console.error('Error signing up:', error));


    Log In:

    import { logIn } from './apiUsers';

    logIn('email@example.com', 'password123')
      .then(({ user, session }) => console.log('User logged in:', user))
      .catch(error => console.error('Error logging in:', error));


    Log Out:

    import { logOut } from './apiUsers';

    logOut()
      .then(() => console.log('User logged out'))
      .catch(error => console.error('Error logging out:', error));


    Update User:

    import { updateUser } from './apiUsers';

    updateUser({ password: 'newpassword123' })
      .then(user => console.log('User updated:', user))
      .catch(error => console.error('Error updating user:', error));


    Send Password Recovery Email:

    import { sendPasswordRecovery } from './apiUsers';

    sendPasswordRecovery('email@example.com')
      .then(data => console.log('Password recovery email sent:', data))
      .catch(error => console.error('Error sending password recovery email:', error));


    Create User in Table:

    import { createUser } from './apiUsers';

    createUser('users', { email: 'email@example.com', name: 'John Doe' })
      .then(data => console.log('User created in table:', data))
      .catch(error => console.error('Error creating user in table:', error));


    Update User in Table:

    import { updateUserInTable } from './apiUsers';

    updateUserInTable('users', userId, { name: 'Jane Doe' })
      .then(data => console.log('User updated in table:', data))
      .catch(error => console.error('Error updating user in table:', error)); */
